// extracted by mini-css-extract-plugin
export var statItem = "_cy-1";
export var statsRow = "_cy-0";